import { styled } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';

// ============================================
// Modal Layout
// ============================================
export const ModalBox = styled(Box)({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '480px',
  backgroundColor: '#fff',
  borderRadius: '12px',
  outline: 'none',
  overflow: 'hidden',
});

export const ModalHeader = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  height: '56px',
  padding: '0 24px',
  backgroundColor: '#3d3d3d',
});

export const ModalTitle = styled(Typography)({
  fontSize: '18px',
  fontWeight: 600,
  color: '#fff',
});

export const ModalBody = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: '20px',
  padding: '32px 24px',
});

export const FieldRow = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: '16px',
});

export const FieldLabel = styled(Typography)({
  width: '90px',
  flexShrink: 0,
  fontSize: '15px',
  fontWeight: 600,
  color: '#262626',
});

export const FieldControl = styled(Box)({
  flex: 1,
  '& > *': {
    width: '100%',
  },
});

export const FieldValue = styled(Typography)({
  fontSize: '15px',
  fontWeight: 500,
  color: '#262626',
});

// 조정 후 잔액 미리보기. 회수로 음수가 되면 빨갛게.
export const PreviewText = styled(Typography, {
  shouldForwardProp: prop => prop !== 'isNegative',
})(({ isNegative }) => ({
  fontSize: '14px',
  fontWeight: 600,
  color: isNegative ? '#dc2626' : '#737373',
}));

export const ModalFooter = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '12px',
  padding: '0 24px 28px',
});
